
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Historie',
	'noDashboardFound': 'Historien kan ikke hentes. Enten findes det ikke længere, eller også har du ikke rettighed til at få vist det.',
	'noDashboardCapability': 'Du har ikke mulighed for at bruge historier',
	'noDashboardPermision': 'Du har ikke de nødvendige rettigheder til at få vist denne historie',
	'defaultName': 'Ny historie',
	'storyProperties': 'Historieegenskaber',
	'createAvDataStoryLabel': 'Historie',
	'createAvSlideShowLabel': 'Slideshow',
	'createAvPanAndZoomLabel': 'Guidet rejse',
	'dashboard_save_success': 'Din historie er gemt.',
	'cmEmptySelection': 'Historien er blevet slettet. Prøv at gemme den som en ny historie.',
	'createStoryTitle': 'Opret en historie',
	'transitionStyleTitle': 'Transitionstypografi',
	'createButton': 'Opret',
	'cancelButton': 'Annullér',
	'dashboardResetTitle': 'Nulstil historie',
	'dashboardResetMessage': 'Er du sikker på, at du vil nulstille alle anvendte ændringer til denne historie?',
	'dashboardResetToast': 'Din historie er blevet nulstillet.',
	'filter_drag_and_drop_all_tabs': 'Træk og placér data her for at filtrere alle scener.',
	'filter_drag_and_drop_current_tab': 'Træk og placér data her for at filtrere denne scene.',
	'filterIconLabel_Global': 'Alle scener',
	'filterIconLabel_Tab': 'Denne scene',
	'filterIconTooltip_Global': 'Alle scener',
	'filterIconTooltip_Tab': 'Denne scene',
	'filterOverflowMenu_Global': 'Alle sceners overløbsmenu',
	'filterOverflowMenu_Tab': 'Denne scenes overløbsmenu',
	'renameScene': 'Omdøb scene',
	'duplicateScene': 'Duplikér scene',
	'deleteScene': 'Slet scene',
	'editTimelineHighlight': 'Redigér fremhævning',
	'deleteTimelineHighlight': 'Slet fremhævning',
	'filter_includesAll': 'Inkluderer alle',
	'timeline_highlight_moved_to': 'Tidslinjefremhævning %{id} flyttet til %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Vælg',
	'newDefaultStoryName': 'Historie: %{modelName}',
	'exportLabel': 'Gem',
	'exportAsLabel': 'Gem som:',
	'exportDialogTitle': 'Gem som en historie',
	'exportDialogFooter': 'Gem- og Annullér-knapper',
	'loadAfterExportLabel': 'Åbn historie efter lagring',
	'selectTemplateLabel': 'Vælg en skabelon',
	'outOfBoundsWarningMessage': 'Nogle dashboardwidgetter er uden for gitteret og vises muligvis ikke korrekt efter eksporten.',
	'emptyExploreCardsWarningMessage': 'Tomme kort blev slettet i forbindelse med gem som en historie.',
	'dashboard_export_success': 'Dit dashboard er gemt som en historie.',
	'explore_export_success': 'Din udforskning er gemt som en historie.',
	'toastUpgradeDone': 'Din historie er blevet opgraderet. Gem nu for at bevare den optimale ydeevne.',
	'navigationMarker': 'Navigationsmærke',
	'navigateMarkers': 'Navigeringsmærker',
	'navNextMarker': 'Næste mærke',
	'navPrevMarker': 'Forrige mærke',
	'navPrevMarkerAbbreviated': 'Forr mærke',
	'timelineSettingsButton': 'Indstillinger for playback',
	'autoPlay': 'Afspil alle scener',
	'loop': 'Løkke',
	'refreshData': 'Opfrisk ved start.',
	'slideshowLabel': 'Slideshow',
	'panAndZoomLabel': 'Guidet rejse',
	'slideShowLayoutLabel': 'Slideshow-layout',
	'panAndZoomLayoutLabel': 'Guidet rejselayout',
	'panAndZoomLayoutFooter': 'Et guidet rejselayout er en samling af scener på et enkelt lærred. Hvis du anvender denne historietype, bliver der zoomet ind og panoreret på de enkelte scener i rækkefølge i præsentationen. Dette er forskelligt fra et slideshow, hvor de enkelte scener bliver præsenteret på et nyt lærred. Med det guidede rejselayout med tre scener forbundet med linjer kan du oprette en vandret sekvens af scener. Det kan være nyttigt til at vise en tidslinje.',
	'PanAndZoomLayout1': '5 scener arrangeret i rektangulær form',
	'PanAndZoomLayout2': '5 scener arrangeret i trappeform fra venstre mod højre',
	'PanAndZoomLayout3': '6 scener arrangeret i rektangulær form',
	'PanAndZoomLayout4': '7 scener arrangeret i rektangulær form med 6 små scener øverst og 1 stor scene nederst',
	'PanAndZoomLayout5': '3 scener arrangeret med 2 små scener øverst og 1 stor scene nederst',
	'PanAndZoomLayout6': 'En række med 4 scener arrangeret vandret',
	'pageSelectWarning': 'Vælg en scene.',
	'noSceneTransitionLabel': 'Ingen',
	'sceneTransitionPropertyLabel': 'Sceneovergang',
	'animatedPathSceneTransitionLabel': 'Animeret sti',
	'sweepSceneTransitionLabel': 'Glidende',
	'storyTypeLabel': 'Historietype',
	'layoutLabel': 'Layout',
	'tabName_animation': 'Animering',
	'propAniAnimation': 'Animering',
	'propAniTypeEntrance': 'Indgangsanimation',
	'propAniDirectionIn': 'Indgangsretning',
	'propAniTypeExit': 'Afslutningsanimation',
	'propAniDirectionOut': 'Afslutningsretning',
	'propAniDirection': 'Retning',
	'propAniEntrance': 'Indgang',
	'propAniTypeEntranceSlideIn': 'Glid ind',
	'propAniTypeEntranceFadeIn': 'Ton ind',
	'propAniTypeEntrancePivotIn': 'Pivotér ind',
	'propAniTypeEntranceScaleIn': 'Skalér ind',
	'propAniTypeEntranceShrinkIn': 'Formindsk ind',
	'propAniDirectionInLeft': 'Fra venstre',
	'propAniDirectionInRight': 'Fra højre',
	'propAniDirectionInTop': 'Fra top',
	'propAniDirectionInBottom': 'Fra bund',
	'propAniExit': 'Afslut',
	'propAniTypeExitSlideIn': 'Glid ud',
	'propAniTypeExitFadeIn': 'Ton ud',
	'propAniTypeExitPivotOut': 'Pivotér ud',
	'propAniTypeExitScaleIn': 'Skalér ud',
	'propAniTypeExitExpandOut': 'Udvid ud',
	'propAniDirectionOutLeft': 'Til venstre',
	'propAniDirectionOutRight': 'Til højre',
	'propAniDirectionOutTop': 'Til top',
	'propAniDirectionOutBottom': 'Til bund',
	'propAniEntranceTime': 'Start (sek.):',
	'propAniExitTime': 'Slut (sek.):',
	'animationNoEntranceText': 'Indgangsanimering sker ikke, hvis widgetten er i starten af scenen.',
	'animationNoExitText': 'Udgangsanimering sker ikke, hvis widgetten er i slutningen af scenen.',
	'propAniTypeDataEntrance': 'Dataindgang',
	'propAniRevealDuration': 'Varighed af indgangsanimering',
	'timelineAnimationProperties': 'Åbn animationsegenskaber',
	'scenesPropertiesSection': 'Scener',
	'editStoryCoachMarkTitle': 'Redigér historie',
	'editStoryCoachMarkContents': 'Klik på blyantsikonen for at redigere historien.',
	'addDataStoryCoachMarkContents': 'Træk data fra datavinduet, og placér dem på historien.',
	'expandSceneCoachmarkTitle': 'Åbn tidslinje',
	'expandSceneCoachmarkContents': 'Animér en scene ved at justere objektsynligheden på basis af tid og varighed.',
	'overviewCoachmarkTitle': 'Oversigtsscener',
	'overviewCoachmarkContents': 'Brug oversigtsscenerne i starten og slutningen af historien til at give et indtryk af alle scener. Fra en oversigtsscene kan du klikke og trække en scene for at udskifte den med en anden scene. Du kan vise eller skjule oversigtsscener i egenskaberne til historien.',
	'animatedPathCoachmarkTitle': 'Animeret sti',
	'animatedPathCoachmarkContents': 'Duplikér en scene med et objekt for at animere et objekt fra én scene til en anden. Flyt, tilpas størrelse eller rotér det duplikerede objekt på den nye scene.',
	'propShowStoryOverviewFirstSlide': 'Vis alle scener i starten',
	'propShowStoryOverviewLastSlide': 'Vis alle scener i slutningen',
	'storySceneSingleCountLabel': '1 scene',
	'storySceneCountLabel': '%{count} scener',
	'storySceneRangeCountLabel': 'Scene %{index} af %{count}',
	'storySceneExpand': 'Åbn tidslinje',
	'storySceneActionMenu': 'Start menuen med sceneindstillinger',
	'timelineRightContainerLabel': 'Kontrolgruppe til tidslinjeknap',
	'timelineViewLabel': 'Tidslinje',
	'timelineZoomFit': 'Zoom til fuld side',
	'timelineZoomIn': 'Zoom ind',
	'timelineZoomOut': 'Zoom ud',
	'timelinePositionIndicator': 'indikator for position af tidslinje på %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'indikator for position på tidslinje - flyt til venstre til %{position}',
	'timelinePositionIndicatorMoveRightTo': 'indikator for position på tidslinje - flyt til højre til %{position}',
	'sceneStart': 'Gå til starten af scenen til %{position}',
	'sceneEnd': 'Gå til slutningen af scenen til %{position}',
	'timelineHighlightTitle': 'Fremhævning',
	'addTimelineHighlight': 'Tilføj fremhævning',
	'addSceneBtnTitle': 'Tilføj en ny scene med standardskabelon',
	'addSceneChevronBtnTitle': 'Vælg en sceneskabelon',
	'timelinePlay': 'Afspil',
	'timelinePause': 'Pause',
	'sceneNavigation': 'Scenenavigering',
	'navNextScene': 'Næste scene',
	'navPrevScene': 'Forrige scene',
	'navPrevSceneAbbreviated': 'Forr scene',
	'navExitFullScreen': 'Afslut fuld skærm',
	'navToggleOverview': 'Aktivér/deaktivér oversigt',
	'rowNumber': 'Række %{number}',
	'overviewBtnLabel': 'Oversigt',
	'sceneListStart': 'Oversigt - start',
	'sceneListEnd': 'Oversigt - slut',
	'timelineLeftHandle': 'venstre håndtag for %{name}',
	'timelineRightHandle': 'højre håndtag for %{name}',
	'timelineLeftHandleNoTitle': 'venstre håndtag',
	'timelineRightHandleNoTitle': 'højre håndtag',
	'timelineMoveLeft': 'Flyt %{object} til venstre',
	'timelineMoveRight': 'Flyt %{object} til højre',
	'timelineMoveWidget': 'Tidslinjewidget flyttet til %{newStartTime} og %{newEndTime}',
	'timelineMoveWidgetStartTime': 'Starttidspunkt for tidslinjewidget ændret til %{newStartTime}',
	'timelineMoveWidgetEndTime': 'Sluttidspunkt for tidslinjewidget ændret til %{newEndTime}',
	'timelineMoveWidgetDown': 'Tidslinjewidget flyttet ned',
	'timelineMoveWidgetUp': 'Tidslinjewidget flyttet op',
	'addSceneTitle': 'Tilføj en scene',
	'blankSceneLayout': 'Tom',
	'titleSceneLayout': 'Titel med undertitel',
	'sceneLayout1': 'Titel med tekst ved siden af en enkelt visualisering',
	'sceneLayout2': 'Titel med én visualisering',
	'sceneLayout3': 'Titel med to visualiseringer',
	'sceneLayout4': 'Multiformål',
	'sceneLayout5': 'Ingen titel med tekst ved siden af en enkelt visualisering',
	'sceneLayout6': 'Multiformål 2 gange 2',
	'sceneLayout7': 'Multiformål 2 ved siden af 1',
	'sceneLayout8': 'Multiformål 1 ved siden af 2',
	'sceneLayout9': 'Multiformål 1 over 2',
	'sceneLayout10': 'Multiformål 2 over 1',
	'sceneLayout11': 'Multiformål 4 over 1',
	'sceneLayout12': 'Multiformål 1 over 1 ved siden af 2 gange 2 over 1',
	'titleWidgetPlaceholderText': 'Indtast titlen her',
	'subtitleWidgetPlaceholderText': 'Indtast undertitlen her',
	'createStoryViewTitle': 'Opret historie',
	'defaultStoryName': 'Ny historie',
	'screenshot_label': 'Historie %{title}',
	'screenshot_label_scene': 'Scene %{sceneTitle} af historie %{title}',
	'filmstripHandleOpenLabel': 'Åbn scenevælger',
	'filmstripHandleCloseLabel': 'Luk scenevælger'
});
